import { spacing } from '@material-ui/system';
import MuiButton from '@material-ui/core/Button';
import { styled } from '@material-ui/core';

const Button = styled(MuiButton)(spacing);

export default Button;

Button.defaultProps = {
	variant: 'contained',
	disableRipple: true,
	disableElevation: true
};
